<button type="button" class="btn-transparent" [ngClass]="styles.button" [attr.aria-label]="headerTitle + ' - ' + ((expanded ? 'UI_CollapsableSection_Collapse' : 'UI_CollapsableSection_Expand') | translate)" [tooltip]="(expanded ? 'UI_CollapsableSection_Collapse' : 'UI_CollapsableSection_Expand') | translate" (click)="toggleExpanded()">
	<span>{{ headerTitle}}</span>
	<span class="glyphicons" [ngClass]="expanded ? 'chevron-down' : 'chevron-right'"></span>
</button>

<div [ngClass]="styles.contentv2" [collapse]="!expanded">
	<ng-content></ng-content>
</div>

